/**
 * A-06 / D8: Context-sensitive query keys.
 *
 * Every server query that depends on organization/branch/client scope must
 * begin with this prefix so that a context switch can remove them atomically.
 */
export const contextQueryKeyPrefix = ['context'] as const;

export function buildContextQueryKey(
  organizationId: string | undefined,
  branchId: string | undefined,
  clientAccountId: string | undefined,
  domain: string,
  ...rest: unknown[]
): unknown[] {
  return [
    ...contextQueryKeyPrefix,
    organizationId ?? '_none_',
    branchId ?? '_none_',
    clientAccountId ?? '_none_',
    domain,
    ...rest,
  ];
}

export function contextScopeQueryKey(
  organizationId: string | undefined,
  branchId: string | undefined,
): unknown[] {
  return [...contextQueryKeyPrefix, organizationId ?? '_none_', branchId ?? '_none_'];
}
